import { Button } from "@chakra-ui/react";
import React from "react";

function CustomButton({
  btnTitle,
  onClick,
  type,
  isLoading,
  leftIco,
  rightIco,
  size,
  weight,
  height,
  radius,
  maxW,
  color,
  bg,
  border,
  borderColor,
}: any) {
  return (
    <Button
      onClick={onClick}
      type={type || "button"}
      isLoading={isLoading}
      fontSize={size || "16px"}
      fontWeight={weight || "700"}
      borderRadius={radius || "8px"}
      minH={height || "48px"}
      maxW={maxW || "188px"}
      w="100%"
      color={color || "#fff"}
      border={border || "none"}
      borderColor={borderColor || "transparent"}
      bg={bg || "yess.secondary_blue"}
      className="aeonik-regular"
      _hover={{
        bg: bg || "yess.secondary_blue",
      }}
      display="flex"
      alignContent="center"
      justifyContent="center"
      gap="8px"
    >
      {leftIco && <div>{leftIco}</div>}
      {btnTitle}
      {rightIco && rightIco}
    </Button>
  );
}

export default CustomButton;
